import React from "react";
import ServicePageTemplate from "@/components/common/ServicePageTemplate";

export default function SourcingServices() {
  return (
    <ServicePageTemplate
      seo={{
        title: "Product Sourcing Services | Premier Global Sourcing",
        description: "Product sourcing, supplier coordination, custom procurement and sample coordination across China, the Middle East and beyond.",
        path: "/sourcing-services",
      }}
      breadcrumbs={[{ label: "Sourcing Services" }]}
      eyebrow="Sourcing Services"
      title="Product sourcing built around your specifications"
      intro="Share the product, specifications, quantity and target market. We review the requirement and research suitable sourcing options for further evaluation."
      leadCopy="Sourcing works best when it starts from a clear requirement. We help you define what you need, then research suitable options so you can evaluate them with confidence."
      image="https://images.unsplash.com/photo-1632914146475-bfe6fa6b2a12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100"
      imageAlt="Professional reviewing product specifications in an industrial setting"
      bullets={[
        "Requirement and specification review before sourcing begins",
        "Research into suitable sourcing options for evaluation",
        "Supplier communication and quotation organization",
        "Sample coordination where available",
      ]}
      subServices={[
        { icon: "Search", title: "Product Sourcing", copy: "Share the product, specifications, quantity and target market. We research suitable sourcing options for further evaluation." },
        { icon: "Network", title: "Supplier Coordination", copy: "Organize supplier communication, quotations, product details, samples and production-related information." },
        { icon: "Crosshair", title: "Custom Procurement", copy: "Conduct a focused supplier and market search for unusual, specialized or hard-to-locate requirements." },
        { icon: "Package", title: "Sample Coordination", copy: "Coordinate sample requests where available before larger commercial orders are considered." },
      ]}
      note="Sourcing options presented are for your evaluation. We coordinate suppliers and information but do not offer blanket quality or delivery guarantees; regulated services may be arranged through qualified partners where applicable."
    />
  );
}
